"use client";

import { useEffect } from "react";
import { useRouter, usePathname } from "next/navigation";
import { NavigationTracker } from "@/utils/navigationTracker";


export default function ViewTransitionWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    NavigationTracker.push(pathname);

    const handleClick = (e: MouseEvent) => {
      const anchor = (e.target as HTMLElement)?.closest("a");
      if (!anchor || anchor.target === "_blank" || e.metaKey || e.ctrlKey)
        return;

      const href = anchor.getAttribute("href");
      if (
        !href ||
        href.startsWith("http") ||
        href.startsWith("#") ||
        href === pathname
      )
        return;

      e.preventDefault();

      
      document.documentElement.dataset.transition = "forward";

    
      // Start transition immediately
      if ((document).startViewTransition) {
        document.startViewTransition(() => {
          return new Promise((resolve) => {
            setTimeout(() => {
              router.push(href);
              resolve(undefined);
            }, 400);
          });
        });
      } else {
        router.push(href);
      }
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [pathname, router]);

  return <>{children}</>;
}
